module.exports = __webpack_public_path__ + "img/chalkboard.ebd01909.svg";